import axios from '@/core/axios';
import { SupplierContact } from './supplier-contacts.types';

export class SupplierContactsService {
  show(supplier_contact_id: number): Promise<SupplierContact> {
    return axios.get<SupplierContact>(`/supplier-contacts/${supplier_contact_id}`).then(resp => resp?.data);
  }

  new(): Promise<SupplierContact> {
    return axios.get<SupplierContact>(`/supplier-contacts`).then(resp => resp?.data);
  }

  list(supplier_id: number): Promise<SupplierContact[]> {
    return axios.post<SupplierContact[]>(`/supplier-contacts/list`, supplier_id).then(resp => resp?.data);
  }

  create(supplier_contact: SupplierContact): Promise<SupplierContact> {
    return axios.post<SupplierContact>(`/supplier-contacts`, { supplier_contact }).then(resp => resp?.data);
  }

  update(supplier_contact_id: number, supplier_contact: Partial<SupplierContact>): Promise<SupplierContact> {
    if (!supplier_contact_id) throw new Error('Missing supplierContact id in update');
    return axios
      .put<SupplierContact>(`/supplier-contacts/${supplier_contact_id}`, { supplier_contact })
      .then(resp => resp?.data);
  }

  delete(supplier_contact_id: number): Promise<void> {
    return axios.delete<void>(`/supplier-contacts/${supplier_contact_id}/delete`).then(resp => resp?.data);
  }
}

export const supplierContactsService = new SupplierContactsService();
